import { Pipe, PipeTransform } from '@angular/core';
import {UserToBoardRelation, UserRelatedBoard} from "../modele/boardModel";
import {NGXLogger} from "ngx-logger";
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | filterBoardsBasedOnRelations:relations? UserToBoardRelation[]
 * Example:
 *   {{ ["follow", "own"] | exponentialStrength:["own", "follow"] }}
 *   formats to: 1024
 */

@Pipe({name: 'testFilteredBoardListSize'})
export class testFilteredBoardListSizePipe implements PipeTransform {

    transform(boards:UserRelatedBoard[], logger?:NGXLogger): any {
        let subSet:UserRelatedBoard[]=[];
        let lp="testFilteredBoardListSizePipe:";
        if(logger!=null){
            //logger.info(lp,"filter: got board",boards,"got: filter:[",inputFilterList,"]");
            let test=(boards.length==0);
            logger.info(lp,"boards.length",test);
            if(test== true){
                logger.info(lp,"sending number");
                return null;
            } else {
                logger.info(lp,"sending board list");
                return boards;
            }
        }
    }
}
